<template>
    <div>
        <img style="width: 100%" src="../../assets/businesslicense.png">
    </div>
</template>

<script>
    export default {
        name: "pictures"
    }
</script>

<style scoped>

</style>
